import { displayValueWithSymbol } from './price';

const productDataFormatter = products => {
  const formattedProductData = products.map((eachProduct, index) => {
    const currentPrice = eachProduct.price.value;
    const actualPrice = eachProduct.wasPriceData.value;
    let calculatedDiscount = 0;
    if (actualPrice !== currentPrice && actualPrice !== 0) {
      calculatedDiscount = Math.round(((actualPrice - currentPrice) / actualPrice) * 100);
    }
    return {
      id: index,
      description: eachProduct.name,
      brand: eachProduct.fnlColorVariantData.brandName,
      model: eachProduct.name,
      currentPrice: displayValueWithSymbol(currentPrice),
      catalogName: eachProduct.catalogName,
      actualPrice: displayValueWithSymbol(actualPrice),
      discount: eachProduct.discountPercent || `${calculatedDiscount}% OFF`,
      descriptionPageURL: eachProduct.url,
      offerPrice: eachProduct.offerPrice,
      priceValue: eachProduct.price.value,
      code: eachProduct.code,
      brickName: eachProduct.brickName,
      productTag: '',
      productColor: eachProduct.fnlColorVariantData.colorGroup,
      productCategory: '',
      productSize: '',
      price: eachProduct.price,
      wasPriceData: eachProduct.wasPriceData,
      fnlColorVariantData: eachProduct.fnlColorVariantData,
      mainImage: eachProduct.wmsPickingImageUrl || eachProduct.images[0].url,
      segmentId: eachProduct?.segmentId || '',
      experimentId: eachProduct?.experimentId || '',
      averageRating: eachProduct?.averageRating || 0,
      numUserRatings: eachProduct?.ratingCount || '',
    };
  });
  return formattedProductData;
};

const checkProductId = (productId = '', localVariable = '') => {
  const getLocalData = JSON.parse(localStorage.getItem(localVariable)) || [];
  const response = getLocalData?.indexOf(productId) !== -1;
  return response;
};

const setProductId = (productId = '', localVariable = '') => {
  const getLocalData = JSON.parse(localStorage.getItem(localVariable)) || [];
  if (getLocalData?.indexOf(productId) === -1) {
    getLocalData?.push(productId);
    localStorage.setItem(localVariable, JSON.stringify(getLocalData));
  }
};

const setProductIdList = (productIds = [], localVariable = '', exitIntent = false) => {
  const getLocalData = JSON.parse(localStorage.getItem(localVariable)) || [];
  productIds?.map(product => {
    const { code = '' } = product;
    const productId = code && code.length > 9 && !exitIntent ? code.substring(0, 9) : code;
    if (getLocalData?.indexOf(productId) === -1) getLocalData?.push(productId);
  });
  localStorage.setItem(localVariable, JSON.stringify(getLocalData));
};

export { productDataFormatter, setProductIdList, checkProductId, setProductId };
